import React from 'react'
import UserInfo from './UserInfo'
import DeviceInfo from './DeviceInfo'
import SubscriptionInfo from './SubscriptionInfo/index'
import RequireAuth from '~/components/RequireAuth'
import TransactionInfo from './TransactionInfo'
import { fetchModels } from '~/redux/models/helpers' 
import userStore from '~/redux/user/store'
import connect from "~/tools/connect";

import './style.css'

class User extends React.Component {
  async componentDidMount() {
    this.setState({ model: await fetchModels() })
  }
  render() {
    return (
      !window.SERVER_SIDE_RENDERING && (
        <RequireAuth user={this.state.user}>
          <div className="user-page">
            <UserInfo user={this.state.user} />
            { this.state.model === 'SVOD' &&
              <SubscriptionInfo user={this.state.user} />
            }
            { this.state.model === 'TVOD' &&
              <TransactionInfo user={this.state.user} />
            }
            <DeviceInfo user={this.state.user} />
          </div>
        </RequireAuth>
      )
    )
  }
}

connect(User, (state) => ({ user: state.user }), userStore)

export default User;
